let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("39Gfh")).then(() => parcelRequire('aDHzd'));